import { Container } from '@mui/material'
import ImportStepper from '../components/ImportStepper/ImportStepper'
import { useDocumentTitle } from '../hooks/useDocumentTitle'

const steps = ['Download Template', 'Populate Template', 'Upload']

export function ImportPage() {
  useDocumentTitle('Import Data')
  return (
    <Container maxWidth="md">
      <ImportStepper />
    </Container>
  )
}

export default ImportPage
